var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jjo9isxmxa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.545 8.182 1.637 1.636 3.682-3.682m-2.87-2.752C7.36 1.47 4.631.957 2.581 2.708s-2.338 4.68-.728 6.75c1.215 1.565 4.669 4.706 6.286 6.149.298.265.446.398.62.45a.83.83 0 0 0 .47 0c.175-.052.323-.185.62-.45 1.618-1.443 5.072-4.584 6.287-6.148 1.61-2.072 1.357-5.018-.728-6.75-2.085-1.734-4.778-1.238-6.414.675z",
    stroke: "#252525",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jjo9isxmxa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHeart);
export default __webpack_public_path__ + "static/media/check-heart.077371b76c205e5d25c13d7c7e338692.svg";
export { ForwardRef as ReactComponent };